import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { selectCriteria } from '../../store/slice'
import { CriteriaIndicator } from '../criteriaIndicator'
import { CriteriaIndustry } from '../criteriaIndustry'
import { CRITERIA_GROUP } from './../../../common/constant'
import { Currency } from './Currency'
import classes from './index.module.scss'

export const CriteriaGroup = ({ criteriaGroup }) => {
  const choosedIdsStr = useSelector(
    selectCriteria([criteriaGroup], (data) => {
      let ids = []

      if (criteriaGroup === CRITERIA_GROUP.INDUSTRY) {
        ids = data.ids.length ? data.ids : data.listIdCheckedTree
      } else {
        ids = Object.values(data)
          .filter(Boolean)
          .map((item) => ({
            createdAt: item.createdAt,
            screeningIndicatorId: item.screeningIndicatorId,
          }))
          .sort((a, b) => a.createdAt - b.createdAt)
          .map((item) => item.screeningIndicatorId)
      }

      return JSON.stringify(ids)
    }),
  )
  const choosedIds = JSON.parse(choosedIdsStr)

  const renderCriteriaIndicators = () => {
    return choosedIds.map((screeningIndicatorId) => (
      <CriteriaIndicator
        key={screeningIndicatorId}
        criteriaGroup={criteriaGroup}
        screeningIndicatorId={screeningIndicatorId}
      />
    ))
  }

  const renderCriteriaIndustry = () => <CriteriaIndustry />

  if (choosedIds.length === 0) return null

  return (
    <Element
      className={`${classes.criteriaGroup} ${
        criteriaGroup === CRITERIA_GROUP.BASIC_INFORMATION ? '' : 'mt1'
      }`}
    >
      <Element
        className={classes.criteriaGroupName}
        style={{
          fontSize: 14,
          backgroundColor: '#F3F3F3',
          padding:
            criteriaGroup === CRITERIA_GROUP.FINANCIALS
              ? '6px 10px'
              : '8px 10px',
        }}
      >
        <Element>
          <Translate value={`screening.${criteriaGroup}`} />
        </Element>
        {criteriaGroup === CRITERIA_GROUP.FINANCIALS && <Currency />}
      </Element>

      <Element>
        {criteriaGroup === CRITERIA_GROUP.INDUSTRY
          ? renderCriteriaIndustry()
          : renderCriteriaIndicators()}
      </Element>
    </Element>
  )
}
